export default __webpack_public_path__ + "static/media/codeImg.666eadbb.jpg";